/**
 * Contentful `type` entries store the namespace either as the legacy
 * screaming-snake code (`PROPERTY_DETAILS`) or as the app namespace directly
 * (`bookAppointment`). Both must resolve to the camelCase namespace the
 * translation keys use, so the standard and ADHA mappers share this helper.
 */
export function normalizeLocaleNamespace(raw: string): string {
  const trimmed = raw.trim();
  if (!/^[A-Z0-9_]+$/.test(trimmed)) {
    return trimmed;
  }
  return trimmed
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1),
    )
    .join('');
}
